import { Campaign, Info, Lock, Notifications } from '@mui/icons-material';

type SvgIconComponent = typeof Campaign;

/** אייקון וצבע כמו בעמודת הקטגוריה ברשימת תבניות Meta (`list/index.tsx`) */
export function getTemplateCategoryListMeta(category: string): {
  Icon: SvgIconComponent;
  color: string;
} {
  if (category === 'MARKETING') {
    return { Icon: Campaign, color: 'primary.main' };
  }
  if (category === 'UTILITY') {
    return { Icon: Notifications, color: 'info.main' };
  }
  if (category === 'AUTHENTICATION') {
    return { Icon: Lock, color: 'warning.main' };
  }
  return { Icon: Info, color: 'text.secondary' };
}

/** כותרת בעברית כמו בעמודת הקטגוריה ברשימה (לתא DataGrid) */
export function getTemplateCategoryHebrewLabel(category: string): string {
  if (category === 'MARKETING') return 'שיווק';
  if (category === 'UTILITY') return 'שירות';
  if (category === 'AUTHENTICATION') return 'אימות';
  return category;
}
